// Estilos para el contenedor principal
export const cajaContenedorStyle = {
  display: 'flex',
  gap: '2.0vh',
  marginLeft: '7vh',
  marginTop: '2.0vh',
  minHeight: '100vh',  
  justifyContent: 'center'
}